<template>
    <div>
        <div class="main-inner">
            <h1 class="mb-3">Afgeronde opnames</h1>

            <div class="row">
                <div class="col-12 col-xl-8">
                    <div v-if="finishedSchedules.data.length === 0" class="alert alert-info">
                        Er zijn geen afgeronde opnames gevonden.
                    </div>

                    <Schedules :schedules="finishedSchedules" @changePage="changePage" type="show"></Schedules>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Schedules from '@/components/schedule/Schedules'
	import { SET_LOADING } from '@/store/modules/loader'
	import { FETCH_FINISHED_SCHEDULES } from '@/store/modules/schedule'

	export default {
		components: { Schedules },
		computed: {
			...mapGetters([
				'currentUser',
				'finishedSchedules',
			]),
		},
		mounted () {
			this.fetchData()
		},
		methods: {
			fetchData (page = 1) {
				this.$store.dispatch(SET_LOADING, true)

				this.$store.dispatch(FETCH_FINISHED_SCHEDULES, page).then(() => {
					this.$store.dispatch(SET_LOADING, false)
				})
			},

			changePage (value) {
				this.fetchData(value)
			},
		},
	}
</script>